import { oxgExtractPriceFromString } from "../../modules/strings"
import { oxgGetLang, oxgLangDeOrEn } from "../../modules/get-lang"

export function oxgAssetBriefingPriceEst() {
  let assetSummaries = document.querySelectorAll('.asset-summary')
  let estimate = document.getElementById('estimated-price')
  let noEstimate = document.getElementById('no-price-estimate')
  let unestimated = document.getElementById('unestimated')
  let assetsWithoutPriceTextContainer = document.getElementById('estimate-addition-assets-without-price')
  let additionalServicesTextContainer = document.getElementById('estimate-additional-services-costs')
  let legal = document.getElementById('price-legal')

  // Translation, Proofreadin, Open Data Options
  let translationLanguages = document.querySelectorAll('.translation-languages')
  let proofreadingYesNo = document.querySelectorAll('.proofreading-yes-no')
  let openDataYesNo = document.querySelectorAll('.open-data-yes-no')
  let openDataRequested = false;
  let proofreadingRequested = false;
  let translationReqeusted = false;

  if (translationLanguages.length > 0) {
    translationReqeusted = true;
  }

  if(openDataYesNo.length > 0) {
    Array.from(openDataYesNo).forEach(entry => {
      let requested = entry.getAttribute('data-is-requested')
      if( requested && requested == 'yes' ) {
        openDataRequested = true
      }
    })
  } 
  if(proofreadingYesNo.length > 0) {
    Array.from(proofreadingYesNo).forEach(entry => {
      let requested = entry.getAttribute('data-is-requested')
      if( requested && requested == 'yes' ) {
        proofreadingRequested = true
      }
    })
  } 

  // 
  let prices = []
  let undefinedCosts = false
  let assetsWithoutEstimate = []
  let someDefinedPrices = false
  if(assetSummaries) {
    Array.from(assetSummaries).forEach(assetSummary => {
      let assetPrice = assetSummary.querySelector('.asset-estimated-price')
      let type = assetSummary.querySelector('.asset-type')
      let id = type.getAttribute('data-asset-id')
      let displayName = assetSummary.querySelector('.asset-display-name')
      let priceText = assetPrice.innerText
      let price = oxgExtractPriceFromString(priceText)
      if (!price) {
        assetsWithoutEstimate.push({
          id: id,
          name: displayName.innerText,
          type: type.innerText,
        })
        undefinedCosts = true
      } else {
        prices.push(price)
        someDefinedPrices = true
      }
    })
  }

  if(!someDefinedPrices) {
    estimate.classList.add('is-hidden')
    noEstimate.classList.remove('is-hidden')
    unestimated.classList.add('is-hidden')
    legal.classList.add('is-hidden')
  }

  let total = 0;
  if (prices.length > 0) {
    prices.forEach(price => {
      total += parseFloat(price)
    })
  }
  // Costs for calculable assets
  if(total) {
    console.log('the estimate html element', estimate)
    let totalString = String(total.toFixed(2)) + ' €'
    totalString = totalString.replace('.', ',')
    console.log('Total price:', total.toFixed(2))
    estimate.innerText = totalString
  }
  // Costs for non calculable assets
  let lang = oxgLangDeOrEn(oxgGetLang())
  if(assetsWithoutEstimate.length > 0) {
    let theText = lang == 'de' ? 'zzgl. Kosten für ' : 'plus costs for ';
    assetsWithoutEstimate.forEach((asset, index) => {
      if (index > 0) {
        theText += ', '
      }
      console.log(asset)
      let assetName = asset['name'] ? asset['name'] : asset['type']
        theText += '"' + assetName + '"'
    })
    assetsWithoutPriceTextContainer.classList.remove('is-hidden')
    assetsWithoutPriceTextContainer.innerText = theText
  } else {
    assetsWithoutPriceTextContainer.innerText = ''
    assetsWithoutPriceTextContainer.classList.add('is-hidden')
  }
  // Costs for additional Services
  if ( translationReqeusted || openDataRequested || proofreadingRequested ) {
    let additionalServiceCosts = lang == 'de' ? 'möglicherweise zzgl. Kosten für ' : 'plus possible costs for ';
    if ( translationReqeusted ) {
      additionalServiceCosts += lang == 'de' ? 'Übersetzungen' : 'translations';
    }
    if (translationReqeusted && openDataRequested) {
      additionalServiceCosts += ' + '
    }
    if ( openDataRequested ) {
      additionalServiceCosts += lang == 'de' ? 'Übertragung offener Daten' : 'delivery of open data';
    }
    if (openDataRequested && proofreadingRequested || (translationReqeusted && !openDataRequested && proofreadingRequested)) {
      additionalServiceCosts += ' + '
    }
    if ( proofreadingRequested ) {
      additionalServiceCosts += lang == 'de' ? 'Lektorat' : 'proofreading';
    }
    additionalServicesTextContainer.classList.remove('is-hidden')
    additionalServicesTextContainer.innerText = additionalServiceCosts
  } else {
    additionalServicesTextContainer.classList.add('is-hidden')
    additionalServicesTextContainer.innerText = ''
  }
}